"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";
import { env } from "@/common/env/client.mjs";
import { isEmpty } from "@/common/helpers/lang";

const getHsq = () => window._hsq || ([] as unknown[]);

const pageView = (initialized: boolean) => {
  const hsq = getHsq();
  const pathWithQueries = document.location.pathname + document.location.search;

  hsq.push(["setPath", pathWithQueries]);
  if (initialized) {
    hsq.push(["trackPageView"]);
  }
};

export function HubSpot() {
  const pathname = usePathname();
  const { NEXT_PUBLIC_HS_PORTAL_ID } = env;

  // biome-ignore lint/correctness/useExhaustiveDependencies: pageView should invoke on every path change
  useEffect(() => {
    pageView(Boolean(window._hsq));
  }, [pathname]);

  if (isEmpty(NEXT_PUBLIC_HS_PORTAL_ID)) {
    return null;
  }

  return (
    <Script
      async
      defer
      type="text/javascript"
      id="hs-script-loader"
      src={`//js-eu1.hs-scripts.com/${NEXT_PUBLIC_HS_PORTAL_ID}.js`}
      strategy="lazyOnload"
    />
  );
}
